
<a-entity position = "-4 0 -4" rotation = "0 45 0">
	<a-entity id="letter-block1" letters-block="letters:CDEFAB;color:red" position = "-1.4 0.15 0"></a-entity>
	<a-entity id="letter-block2" letters-block="letters:HIJKLG;color:green" position = "-1.05.15 0"></a-entity>
	<a-entity id="letter-block3" letters-block="letters:RMNOPQ;color:blue" position = "-0.7 0.15 0"></a-entity>
	<a-entity id="letter-block4" letters-block="letters:IJKLGH;color:green" position = "-0.35 0.15 0"></a-entity>
	<a-entity id="letter-block5" letters-block="letters:STUVWX;color:orange" position = "0 0.15 0"></a-entity>
	<a-entity id="letter-block6" letters-block="letters:TUVWXS;color:orange" position = "0.35 0.15 0"></a-entity>
	<a-entity id="letter-block7" letters-block="letters:MNOPQR;color:blue" position = "0.7 0.15 0"></a-entity>
	<a-entity id="letter-block8" letters-block="letters:ABCDEF;color:red" position = "1.05 0.15 0"></a-entity>
	<a-entity id="letter-block9" letters-block="letters:STUVWX;color:orange" position = "1.4 0.15 0"></a-entity>
	<a-entity id="letter-block10" letters-block="letters:MNOPQR;color:blue" position = "-0.9 0.45 0"></a-entity>
	<a-entity id="letter-block11" letters-block="letters:EFABCD;color:red" position = "-0.55 0.45 0"></a-entity>
	<a-entity id="letter-block12" letters-block="letters:RMNOPQ;color:blue" position = "-0.2 0.45 0"></a-entity>
	<a-entity id="letter-block13" letters-block="letters:RMNOPQ;color:blue" position = "0.15 0.45 0"></a-entity>
	<a-entity id="letter-block14" letters-block="letters:YZ1234;color:purple" position = "0.5 0.45 0"></a-entity>
  </a-entity>


<a-entity position="0 0 -5" shadow="cast: true; receive: true">
<a-entity id="snowman-base" mixin="snowbase" position="0 0.4 -1.5"
    ammo-shape="type:hull"></a-entity>
<a-entity id="snowman-head" mixin="snowbase" scale="0.7 0.7 0.7" position="0 1.1 -1.5"
    ammo-shape="type:hull"></a-entity>
<a-entity id="snowman-nose" mixin="carrot" rotation="90 0 0" position="0 1.1 -1.1"  ammo-shape="type:cone;fit:manual;halfExtents:0.025 0.11 0.025"></a-entity>
<a-entity id="snowman-l-eye" mixin="coal" position="-0.1 1.2 -1.2" ammo-shape="type:sphere;fit:manual;sphereRadius:0.04"></a-entity>
<a-entity id="snowman-r-eye" mixin="coal" position="0.1 1.2 -1.2" ammo-shape="type:sphere;fit:manual;sphereRadius:0.04"></a-entity>
<a-entity id="snowman-mouth1" mixin="coal" position="-0.1 1.02 -1.21" ammo-shape="type:sphere;fit:manual;sphereRadius:0.04"></a-entity>
<a-entity id="snowman-mouth2" mixin="coal" position="-0.05 1 -1.2" ammo-shape="type:sphere;fit:manual;sphereRadius:0.04"></a-entity>
<a-entity id="snowman-mouth3" mixin="coal" position="0 1 -1.2" ammo-shape="type:sphere;fit:manual;sphereRadius:0.04"></a-entity>
<a-entity id="snowman-mouth4" mixin="coal" position="0.05  1 -1.2" ammo-shape="type:sphere;fit:manual;sphereRadius:0.04"></a-entity>
<a-entity id="snowman-mouth5" mixin="coal" position="0.1 1.02 -1.21" ammo-shape="type:sphere;fit:manual;sphereRadius:0.04"></a-entity>
<a-entity id="snowman-hat" mixin="hat" position="0 1.56 -1.5" ammo-shape="type:hull">
</a-entity>
<a-entity id="snowman-l-arm" mixin="branch" rotation="0 0 80" position="-0.6 0.7 -1.5" ammo-shape="type:hull"></a-entity>
<a-entity id="snowman-r-arm" mixin="branch" rotation="0 0 -100" position="0.6 0.7 -1.5" ammo-shape="type:hull"></a-entity>
</a-entity>

<a-entity perimeter-fence position = "0 0 -3"></a-entity>

<a-entity position="0 0 -4" shadow="cast: true; receive: true">
<a-entity id="tree-trunk" mixin="trunk" position="1.5 0.25 0"></a-entity>
<!-- in the past, bables have worked better *not* as children of tree.
unclear if that's still true, but keeping things as consistent as possible for now-->
<a-entity id="tree-base-tier" mixin="tree-tier" scale="1.2 1.2 1.2" position="1.5 0.75 0"
    ammo-shape="type:hull">
</a-entity>
<a-entity position="1.5 0.75 0" rotation="0 90 0">
<a-sphere color="red" cylindrical-position="height: -0.12; radius:0.396; angle:45" mixin="bauble"
      env-map="#env" metalness="1.0" roughness="0.0" radius="0.04" ammo-shape="type:sphere;fit:manual;sphereRadius:0.04"></a-sphere>
<a-sphere color="yellow" cylindrical-position="height: -0.12; radius:0.396; angle:0" mixin="bauble"
      env-map="#env" metalness="1.0" roughness="0.0" radius="0.04" ammo-shape="type:sphere;fit:manual;sphereRadius:0.04"></a-sphere>
<a-sphere color="green" cylindrical-position="height: -0.12; radius:0.396; angle:-45" mixin="bauble"
      env-map="#env" metalness="1.0" roughness="0.0" radius="0.04" ammo-shape="type:sphere;fit:manual;sphereRadius:0.04"></a-sphere>
</a-entity>
<a-entity id="tree-2nd-tier" mixin="tree-tier" position="1.5 1.05 0"
    ammo-shape="type:hull">
</a-entity>

<a-entity position="1.5 1.05 0" rotation="0 90 0">
<a-sphere color="blue" cylindrical-position="height: -0.1; radius:0.33; angle:45" mixin="bauble"
        env-map="#env" metalness="1.0" roughness="0.0" radius="0.04" ammo-shape="type:sphere;fit:manual;sphereRadius:0.04"></a-sphere>
<a-sphere color="silver" cylindrical-position="height: -0.1; radius:0.33; angle:0" mixin="bauble"
        env-map="#env" metalness="1.0" roughness="0.0" radius="0.04" ammo-shape="type:sphere;fit:manual;sphereRadius:0.04"></a-sphere>
<a-sphere color="red" cylindrical-position="height: -0.1; radius:0.33; angle:-45" mixin="bauble"
        env-map="#env" metalness="1.0" roughness="0.0" radius="0.04" ammo-shape="type:sphere;fit:manual;sphereRadius:0.04"></a-sphere>
</a-entity>
<a-entity id="tree-3rd-tier" mixin="tree-tier" scale="0.8 0.8 0.8" position="1.5 1.35 0"
      ammo-shape="type:hull">
</a-entity>
<a-entity position="1.5 1.35 0" rotation="0 90 0">
<a-sphere color="yellow" cylindrical-position="height: -0.08; radius:0.264; angle:45" mixin="bauble"
        env-map="#env" metalness="1.0" roughness="0.0" radius="0.04" ammo-shape="type:sphere;fit:manual;sphereRadius:0.04"></a-sphere>
<a-sphere color="green" cylindrical-position="height: -0.08; radius:0.264; angle:0" mixin="bauble"
        env-map="#env" metalness="1.0" roughness="0.0" radius="0.04" ammo-shape="type:sphere;fit:manual;sphereRadius:0.04"></a-sphere>
<a-sphere color="blue" cylindrical-position="height: -0.08; radius:0.264; angle:-45" mixin="bauble"
        env-map="#env" metalness="1.0" roughness="0.0" radius="0.04" ammo-shape="type:sphere;fit:manual;sphereRadius:0.04"></a-sphere>
</a-entity>
<a-entity id="star" mixin="star" rotation="0 90 0" position="1.45 1.6 0" ammo-shape="type:hull" material="envMap:#env">
</a-entity>

<a-entity id="present1" mixin="present-large" position="1.5 0.2 1"
      ammo-shape="type:box"
      rotation="0 20 0">
<a-entity id="ribbon1" mixin="ribbon-red ribbon-large"></a-entity>
</a-entity>
<a-entity id="present2" mixin="present-medium" position="1.6 0.1 -0.7"
      ammo-shape="type:box"
      rotation="0 -10 0">
<a-entity id="ribbon2" mixin="ribbon-medium ribbon-gold"></a-entity>
</a-entity>
<a-entity id="present3" mixin="present-small" position="1.3 0.05 -0.5"
      ammo-shape="type:box"
      rotation="0 30 0">
<a-entity id="ribbon3" mixin="ribbon-small ribbon-green"></a-entity>
</a-entity>
<a-entity id="present4" mixin="present-medium" position="1.3 0.1 0.5"
      ammo-shape="type:box"
      rotation="0 0 0">
<a-entity id="ribbon4" mixin="ribbon-medium ribbon-green"></a-entity>
</a-entity>
<a-entity id="present5" mixin="present-medium" position="1.1 0.1 -0.2"
      ammo-shape="type:box"
      rotation="0 -30 0">
<a-entity id="ribbon5" mixin="ribbon-medium ribbon-red"></a-entity>
</a-entity>
<a-entity id="present6" mixin="present-small" position="1.1 0.05 0.2"
      ammo-shape="type:box">
<a-entity id="ribbon6" mixin="ribbon-small ribbon-gold"></a-entity>
</a-entity>

<a-entity>
    <!--   <a-entity position="-0.6 0.3 -4.5" mixin="penguin" ammo-shape="type:hull"></a-entity> -->


</a-entity>

</a-entity>